import { render, staticRenderFns } from "./DatasetDetail.vue?vue&type=template&id=5cef2abb&scoped=true&"
import script from "./DatasetDetail.vue?vue&type=script&lang=ts&"
export * from "./DatasetDetail.vue?vue&type=script&lang=ts&"
import style0 from "./DatasetDetail.vue?vue&type=style&index=0&id=5cef2abb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cef2abb",
  null
  
)

export default component.exports